import React from 'react';
import {
  Button, Col, Row,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import {
  IoAlertCircleOutline, IoCheckmarkCircleOutline, IoInformationCircleOutline,
} from 'react-icons/io5';

type MapModalProps = {
  description?: string,
  success?: boolean,
  warning?: boolean,
  onClose: () => void,
  textOtherAction?: string,
  otherAction?: () => void,
};

function SuccessMessage( {
  description, onClose, otherAction, success = true, warning = false, textOtherAction,
}: MapModalProps ) {
  const { t } = useTranslation();
  return (
    <div className="text-center">
      {success === true && !warning && (
        <IoCheckmarkCircleOutline size={34} className="text--green2" />
      )}
      {warning && (
        <IoInformationCircleOutline size={34} className="text--blue2" />
      )}
      {success === false && !warning && (
        <IoAlertCircleOutline size={34} className="text-danger" />
      )}
      <p
        className={classNames( 'text--sm mt-2', {
          'text--green2': success === true && !warning,
          'text--gray20': warning,
          'text-danger': success === false && !warning,
        } )}
        style={{ whiteSpace: 'pre-line' }}
      >
        {description}
      </p>

      {otherAction && textOtherAction && (
      <Row>
        <Col md={8} className="m-auto mt-3">
          <Button variant="link" className="btn--full-width" onClick={otherAction}>
            {t( textOtherAction )}
          </Button>
        </Col>
      </Row>
      )}

      <Row>
        <Col md={8} className="m-auto mt-3">
          <Button variant="primary" className="btn--full-width" onClick={onClose}>
            {t( 'accept' )}
          </Button>
        </Col>
      </Row>
    </div>
  );
}

export default SuccessMessage;
